/**
 * Tiny event bus so any page can ask the live-chat widget to open ("Start a
 * chat" links on Contact / Help). The ChatWidget (iteration 0007) listens for
 * this event; before it mounts, calling openChat() is simply a no-op.
 */
export const OPEN_CHAT_EVENT = 'g4:open-chat'

export function openChat(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(OPEN_CHAT_EVENT))
  }
}
